import React from 'react';

const BabelmixLogo = ({ className = "", size = "medium" }) => {
  const sizeClasses = {
    small: "h-5 w-5",
    medium: "h-6 w-6", 
    large: "h-8 w-8"
  };
  
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img 
        src="/babelmix-logo.png" 
        alt="Babelmix Logo" 
        className={`${sizeClasses[size]} object-contain`}
      />
      <span className="font-bold text-gray-800">Babelmix</span>
    </div>
  );
};

export default BabelmixLogo;
